import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MethodOfTravelToWork from './method-of-travel-to-work';
import MethodOfTravelToWorkDetail from './method-of-travel-to-work-detail';
import MethodOfTravelToWorkUpdate from './method-of-travel-to-work-update';
import MethodOfTravelToWorkDeleteDialog from './method-of-travel-to-work-delete-dialog';

const MethodOfTravelToWorkRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MethodOfTravelToWork />} />
    <Route path="new" element={<MethodOfTravelToWorkUpdate />} />
    <Route path=":id">
      <Route index element={<MethodOfTravelToWorkDetail />} />
      <Route path="edit" element={<MethodOfTravelToWorkUpdate />} />
      <Route path="delete" element={<MethodOfTravelToWorkDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MethodOfTravelToWorkRoutes;
